<app-breadcrumbs [breadcrumbs]="breadcrumbs" [showHome]="false" class="d-block mb-4"></app-breadcrumbs>

<header class="d-flex gap-2 align-items-center mb-3">
  <h2 class="mb-0">
    {{ prefix + '-titel' | fromDictionary }}
  </h2>
</header>

<div class="text-max-width">
  <fstr-dynamic-form [config]="formFields" [appearance]="'fill'" (formSubmit)="handleSubmit($event)" [showSubmit]="false" #form>
    <div slot="form-actions">
      <ng-container *ngIf="addressUpdateErrors$()?.length">
        <app-alert
          class="d-block mb-4"
          *ngIf="addressUpdateErrors$() as errors"
          [status]="'type--danger'"
          [title]="prefix + '-formulier-server-errors-titel' | fromDictionary"
          [showDefaultError]="true"
          [errors]="errors"
        ></app-alert>
      </ng-container>

      <div class="form-footer__actions mt-3">
        <button
          type="button"
          class="button button-outline button--danger"
          (click)="deleteAddress()"
          *ngIf="type !== 'toevoegen' && !isDefaultAddress$()"
          [disabled]="addressUpdating$()"
        >
          <!-- <span class="icon-loader css-icon" title="laden"></span> -->
          <span>{{ prefix + '-verwijderen-knop-tekst' | fromDictionary }}</span>
        </button>
        <button type="submit" class="button button--secondary" [class.w-100]="type === 'toevoegen'" [disabled]="addressUpdating$()">
          <span>{{ prefix + '-knop-tekst' | fromDictionary }}</span>
          <span *ngIf="addressUpdating$()" class="icon-loader css-icon" title="laden"></span>
        </button>
      </div>
    </div>
  </fstr-dynamic-form>

  <app-alert
    class="d-block mt-4"
    *ngIf="addressUpdateSuccess$()"
    [message]="prefix + '-formulier-succes-geslaagd-tekst' | fromDictionary"
    [status]="'type--success'"
    [title]="prefix + '-formulier-succes-geslaagd-titel' | fromDictionary"
  ></app-alert>
</div>
<!-- <pre>{{ address$ | async | json }}</pre> -->
